angular.module('zc.projects')

.directive 'zcCampaignSegmentFlag', ($translate, Devise) ->
  restrict: 'E'
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_segment_flag.html'
  replace: true
  scope:
    segment: "="
    short: "@"
  link: (scope, element, attrs) ->
    scope.getSegmentType = (segment) ->
      if segment
        segment.segment_type
      else
        'custom_old'

    scope.hasExcludableConditions = () ->
      # there's a short time segment is not yet assigned
      return false if !scope.segment || !scope.segment.conditions_json
      scope.segment.conditions_json.advertising ||
        scope.segment.conditions_json.newsletter ||
        scope.segment.conditions_json.logged_in ||
        scope.segment.conditions_json.target_regions ||
        scope.segment.conditions_json.private_browsing ||
        scope.hasValidLimitToLandingPageTypesCondition() ||
        scope.hasValidExcludeLandingPageTypesCondition() ||
        scope.hasValidLimitToOfferPageTypesCondition() ||
        scope.hasValidExcludeOfferPageTypesCondition() ||
        scope.hasValidLimitToSessionsWhoVisitCondition() ||
        scope.hasValidExcludeSessionsWhoVisitCondition() ||
        scope.hasValidTriggersCondition()

    scope.hasValidLimitToLandingPageTypesCondition = () ->
      # there's a short time segment is not yet assigned
      return false if !scope.segment || !scope.segment.conditions_json
      scope.segment.conditions_json.limit_to_landing_page_types &&
        scope.segment.conditions_json.limit_to_landing_page_types.length &&
        scope.segment.conditions_json.limit_to_landing_page_types[0] != 'NOT_SELECTED'

    scope.hasValidExcludeLandingPageTypesCondition = () ->
      # there's a short time segment is not yet assigned
      return false if !scope.segment || !scope.segment.conditions_json
      scope.segment.conditions_json.exclude_landing_page_types &&
        scope.segment.conditions_json.exclude_landing_page_types.length &&
        scope.segment.conditions_json.exclude_landing_page_types[0] != 'NOT_SELECTED'

    scope.hasValidLimitToOfferPageTypesCondition = () ->
      # there's a short time segment is not yet assigned
      return false if !scope.segment || !scope.segment.conditions_json
      scope.segment.conditions_json.limit_to_offer_page_types &&
        scope.segment.conditions_json.limit_to_offer_page_types.length &&
        scope.segment.conditions_json.limit_to_offer_page_types[0] != 'NOT_SELECTED'

    scope.hasValidExcludeOfferPageTypesCondition = () ->
      # there's a short time segment is not yet assigned
      return false if !scope.segment || !scope.segment.conditions_json
      scope.segment.conditions_json.exclude_offer_page_types &&
        scope.segment.conditions_json.exclude_offer_page_types.length &&
        scope.segment.conditions_json.exclude_offer_page_types[0] != 'NOT_SELECTED'

    scope.hasValidLimitToSessionsWhoVisitCondition = () ->
      # there's a short time segment is not yet assigned
      return false if !scope.segment || !scope.segment.conditions_json
      scope.segment.conditions_json.limit_to_sessions_who_visit &&
        scope.segment.conditions_json.limit_to_sessions_who_visit.length &&
        scope.segment.conditions_json.limit_to_sessions_who_visit[0] != 'NOT_SELECTED'

    scope.hasValidExcludeSessionsWhoVisitCondition = () ->
      # there's a short time segment is not yet assigned
      return false if !scope.segment || !scope.segment.conditions_json
      scope.segment.conditions_json.exclude_sessions_who_visit &&
        scope.segment.conditions_json.exclude_sessions_who_visit.length &&
        scope.segment.conditions_json.exclude_sessions_who_visit[0] != 'NOT_SELECTED'

    scope.hasValidTriggersCondition = () ->
      # there's a short time segment is not yet assigned
      return false if !scope.segment || !scope.segment.conditions_json
      scope.segment.conditions_json.triggers &&
        scope.segment.conditions_json.triggers.length &&
        scope.segment.conditions_json.triggers[0] != 'NOT_SELECTED'

    scope.hasAdditionalCustom = ->
      return false if !scope.segment || scope.segment.segment_type is 'custom'
      scope.segment.json isnt '{}'


    scope.Devise = Devise
    scope.$watch 'segment', (newVal, oldVal) ->
      if newVal and newVal.segment_type
        typeText = switch newVal.segment_type
          when 'new'
            $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.new')
          when 'cv_users'
            $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.cvUsers')
          when 'new_inverse'
            $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.newInverse')
          when 'inactive'
            $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.inactive')
          when 'custom'
            $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.custom')
          when 'all'
            $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.all')
          else
            $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.custom')
      else
        typeText = $translate.instant('projectsCampaigns.directives.campaignSegmentFlag.custom')

      scope.typeText = typeText



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_segment_flag.coffee